import React from 'react';
import { useSelector } from 'react-redux';
import { Button, ScreenContainer, ContentFrame, LayoutControls, } from '@pinwheel/origami';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import ModalHeader from '../../components/ModalHeader';
import { useOpts } from '../../context';
import FontCard from '../../components/FontCard';
import { DD_FORM_SIGNATURE_STYLES } from '../../types/dd-forms';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import '../../style/dd-forms/fonts';
import { EventAction, EventType } from '../../types/events';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var SignatureStyleSelection = function () {
    var _a = useDDFormContext(), goBack = _a.goBack, setSignatureStyle = _a.setSignatureStyle, userName = _a.userName, signatureStyle = _a.signatureStyle;
    var getLocalizedString = useGetLocalizedString();
    var fireUnifiedEvent = useOpts().fireUnifiedEvent;
    var navigate = useLinkNavigate();
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var handleSubmit = function () {
        fireUnifiedEvent(EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT, {
            action: EventAction.CONTINUE,
            signature: signatureStyle,
            entry_point: lastSource,
            source: currentSource,
        });
        navigate('/dd-form/confirmation-screen');
    };
    var handleSelect = function (value) {
        fireUnifiedEvent(EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT, {
            action: EventAction.SELECT_SIGNATURE,
            signature: value,
            entry_point: lastSource,
            source: currentSource,
        });
        setSignatureStyle(value);
    };
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { onBack: goBack }),
        React.createElement(ContentFrame, null,
            React.createElement(TitleFrame, { title: getLocalizedString('DIRECT_DEPOSIT_FORM'), subtitle: getLocalizedString('SIGNATURE_STYLE_PROMPT'), "data-testid": "SignatureStyleSelection" },
                React.createElement("div", null, DD_FORM_SIGNATURE_STYLES.map(function (style, i) { return (React.createElement(FontCard, { key: i, "data-testid": "cardOption".concat(i), eventId: "DDForm-selectSignature", onClick: function () { return handleSelect(style); }, signatureStyle: style, displayText: userName, sx: { marginBottom: '16px' } })); }))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { eventId: "DDForm-signatureContinue", dataTestId: "button-continue", onClick: handleSubmit }, getLocalizedString('CONTINUE'))))));
};
export default SignatureStyleSelection;
